import * as React from 'react'
import { IManagerConfiguration, IRamConfiguration } from 'src/ServerEntities/IConfiguration';

interface IProps {
    children?: React.ReactNode;
}

interface ISetRoleAction {
    type: "setRole",
    payload: string
};

interface ISetRamConfigurationAction {
    type: "setRamConfiguration",
    payload: IRamConfiguration
};

interface ISetManagerConfigurationAction {
    type: "setManagerConfiguration",
    payload: IManagerConfiguration
};

interface ISetRoleDisplayNameAction {
    type: "setRoleDisplayName",
    payload: string
}

interface IClearRoleAction {
    type: "clearRole"
};

interface IRolesState {
    managerConfiguration?: IManagerConfiguration,
    ramConfiguration?: IRamConfiguration,
    role?: string,
    roleDisplayName?: string
    
}

type Actions = ISetRoleAction |  ISetRoleDisplayNameAction | IClearRoleAction | ISetManagerConfigurationAction | ISetRamConfigurationAction;

const initialState: IRolesState = {
    managerConfiguration: undefined,
    role: undefined,
    roleDisplayName: undefined
}

const reducer = (state: typeof initialState, action: Actions): IRolesState => {
    switch (action.type) {
        case "setRole":
            return { ...state, role: action.payload };    
         case "setRoleDisplayName":
            return { ...state, roleDisplayName: action.payload };        
        case "setRamConfiguration":
            return { ...state, ramConfiguration: action.payload };
        case "setManagerConfiguration":
            return { ...state, managerConfiguration: action.payload };
        case "clearRole":
            return { ...state, role: undefined, roleDisplayName: undefined };
    }
};

// const RolesContext = React.createContext(initialState as unknown as { state: IRolesState, dispatch: React.Dispatch<Actions> });

const RolesContext = React.createContext<{ state: IRolesState, dispatch: React.Dispatch<Actions> }>({
    state: initialState,
    dispatch: () => null
});

const RolesContextProvider = (props: IProps) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    
     return <RolesContext.Provider value={{ state, dispatch }}>
        {props.children}
    </RolesContext.Provider>
};

export { RolesContext, RolesContextProvider };
